// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"a8ba428f","878":"a7ea27b7"}[chunkId] + ".chunk.js";
};